'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const PaginationContext = createContext(null);
function usePaginationContext() {
    return useNonNullishContext(PaginationContext);
}

export { PaginationContext, usePaginationContext };
